import React, { Component } from 'react';
import { Animated, BackHandler, PanResponder, StyleSheet, View, Keyboard, TouchableOpacity, Dimensions } from 'react-native';
import { ModalAlignmentEnum } from "@voltmoney/types";
import { Icon } from "../icon/Icon";
import { ColorTokens, IconSizeTokens, IconTokens } from "@voltmoney/schema";
let panResponder;
let initialHeight = Dimensions.get('window').height;
class BottomSheet extends Component {
    id;
    timer;
    showSubscription;
    hideSubscription;
    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            animatedHeight: new Animated.Value(0),
            pan: new Animated.ValueXY(),
            calculatedHeight: 0,
            keyboardHeight: 0,
        };
        if (!this.props.autoAdjustHeight) {
            this.createPanResponder(props);
        }
    }
    setModalVisible(visible) {
        const { closeFunction, height } = this.props;
        const { animatedHeight, pan, calculatedHeight, } = this.state;
        if (visible) {
            this.setState({ modalVisible: visible });
            Animated.timing(animatedHeight, {
                toValue: this.props?.autoAdjustHeight
                    ? calculatedHeight
                    : height,
                duration: 300,
                useNativeDriver: false,
            }).start();
        }
        else {
            Animated.timing(animatedHeight, {
                toValue: 0,
                duration: 400,
                useNativeDriver: false,
            }).start(() => {
                pan.setValue({ x: 0, y: 0 });
                this.setState({
                    modalVisible: visible,
                    animatedHeight: new Animated.Value(0),
                });
                if (typeof closeFunction === 'function')
                    closeFunction();
            });
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            Animated.timing(this.state.animatedHeight, {
                toValue: this.props.height,
                duration: 300,
                useNativeDriver: false,
            }).start();
            if (this.props.isCTAClicked) {
                this.close();
            }
        }
    }
    createPanResponder(props, customHeight) {
        const { height } = props;
        const { pan } = this.state;
        panResponder = PanResponder.create({
            onStartShouldSetPanResponder: () => true,
            onPanResponderMove: (e, gestureState) => {
                if (gestureState.dy > 0) {
                    Animated.event([null, { dy: pan.y }], {
                        useNativeDriver: false,
                    })(e, gestureState);
                }
            },
            onPanResponderRelease: (e, gestureState) => {
                const gestureLimitArea = customHeight
                    ? customHeight
                    : height / 3;
                const gestureDistance = gestureState.dy;
                if (gestureDistance > gestureLimitArea) {
                    this.setModalVisible(false);
                }
                else {
                    Animated.spring(pan, {
                        toValue: { x: 0, y: 0 },
                        useNativeDriver: true,
                    }).start();
                }
            },
        });
    }
    handleResize = () => {
        // Check the screen dimensions to determine if the virtual keyboard is open
        const { height } = Dimensions.get('window');
        if (height < initialHeight) {
            this.setState({ keyboardHeight: 200 });
        }
        else {
            this.setState({ keyboardHeight: 0 });
        }
    };
    componentDidMount() {
        if (!this.props.autoAdjustHeight)
            this.show();
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
        if (this.props.handleKeyboard) {
            Dimensions.addEventListener('change', this.handleResize);
            this.showSubscription = Keyboard.addListener("keyboardDidShow", (e) => {
                this.setState({ keyboardHeight: e.endCoordinates.height });
            });
            this.hideSubscription = Keyboard.addListener("keyboardDidHide", () => {
                this.setState({ keyboardHeight: 0 });
            });
        }
    }
    componentWillUnmount() {
        clearTimeout(this.timer);
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);
        if (this.props.handleKeyboard) {
            this.showSubscription.remove();
            this.hideSubscription.remove();
        }
    }
    handleBackButton() {
        return this.props?.isDismissible;
    }
    show() {
        this.setModalVisible(true);
    }
    close() {
        this.setModalVisible(false);
    }
    render() {
        const { id, children, hasDraggableIcon, sheetBackgroundColor, dragIconColor, dragIconStyle, draggable = true, radius = 4, backgroundColorPartner = '#25252599' } = this.props;
        const { animatedHeight, pan, modalVisible } = this.state;
        const panStyle = {
            transform: pan.getTranslateTransform(),
        };
        if (this.props.autoAdjustHeight &&
            this.state.calculatedHeight === 0) {
            return (React.createElement(TouchableOpacity, { onPress: () => {
                    if (this.props.isDismissible) {
                        this.close();
                        this.setState({ modalVisible: false });
                    }
                }, style: { opacity: 0 }, onLayout: (event) => {
                    clearTimeout(this.timer);
                    const { height } = event.nativeEvent.layout;
                    console.info(`**** calculated modal height for ${this.props.routeId} -> ', ${height}`);
                    this.createPanResponder(this.props, height);
                    this.timer = setTimeout(() => this.setState({
                        calculatedHeight: hasDraggableIcon
                            ? height + 80
                            : height,
                    }, () => {
                        this.show();
                    }), 60);
                } }, children));
        }
        const _renderDragIcon = (React.createElement(Animated.View, { ...(draggable && panResponder.panHandlers), style: styles.draggableContainer },
            React.createElement(View, { style: [
                    styles.draggableIcon,
                    dragIconStyle,
                    {
                        backgroundColor: dragIconColor || '#A3A3A3',
                    },
                ] })));
        return (React.createElement(TouchableOpacity, { onPress: () => {
                if (this.props.isDismissible) {
                    this.close();
                    // this.setState({modalVisible: false})
                }
            }, activeOpacity: 1, style: [{
                    // flex: 1,
                    height: this.props.screenHeight,
                    width: this.props.screenWidth,
                    marginBottom: typeof this.props.explicitMarginBottom === 'number' ? this.props.explicitMarginBottom : this.props.hideMarginBottom ? -10 : 5,
                    backgroundColor: backgroundColorPartner,
                    marginTop: this.props.hideMarginBottom && -20
                },
                this.props.alignment === ModalAlignmentEnum.BOTTOM ? {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                } : {}] },
            modalVisible && (React.createElement(Animated.View, { style: [
                    panStyle,
                    this.props.alignment === ModalAlignmentEnum.BOTTOM ? {
                        height: animatedHeight,
                        width: this.props.screenWidth,
                        borderTopRightRadius: 20,
                        borderTopLeftRadius: 20,
                        backgroundColor: sheetBackgroundColor || '#F3F3F3',
                    } :
                        this.props.alignment === ModalAlignmentEnum.LEFT ? {
                            width: animatedHeight,
                            height: '100%',
                            position: 'absolute',
                            left: 0,
                            borderTopLeftRadius: radius || 12,
                            borderBottomLeftRadius: radius || 12,
                            backgroundColor: sheetBackgroundColor || '#F3F3F3',
                        } : this.props.alignment === ModalAlignmentEnum.RIGHT ? {
                            width: animatedHeight,
                            height: '100%',
                            position: 'absolute',
                            right: 0,
                            borderTopRightRadius: radius || 12,
                            borderBottomRightRadius: radius || 12,
                            backgroundColor: sheetBackgroundColor || '#F3F3F3',
                        } : {
                            height: animatedHeight,
                            width: '100%',
                            position: 'absolute',
                            top: 0,
                            borderBottomRightRadius: radius || 12,
                            borderBottomLeftRadius: radius || 12,
                            backgroundColor: sheetBackgroundColor || '#F3F3F3',
                        },
                ] },
                hasDraggableIcon && _renderDragIcon,
                children,
                this.props.isDismissible && React.createElement(TouchableOpacity, { onPress: () => {
                        this.close();
                    }, style: { position: 'absolute', right: 0, top: 0, padding: 16, zIndex: 1 } },
                    React.createElement(Icon, { id: id, name: IconTokens.Cross, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Night })))),
            this.state.keyboardHeight > 0 && (React.createElement(View, { style: { height: this.state.keyboardHeight } }))));
    }
}
export default BottomSheet;
const styles = StyleSheet.create({
    wrapper: {
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    background: {
        flex: 1,
        backgroundColor: 'transparent',
    },
    container: {
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,
    },
    draggableContainer: {
        width: '100%',
        alignItems: 'center',
        backgroundColor: 'transparent',
        paddingBottom: 8,
    },
    draggableIcon: {
        width: 40,
        height: 6,
        borderRadius: 3,
        margin: 10,
        marginBottom: 0,
    },
});
